module.exports = __webpack_public_path__ + "static/media/patrol(31).c0d4734c.PNG";